import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import GlobalDatagrid from '../../components/mui/DataGrid/GlobalDatagrid';
import { Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { REFUND_SCHEDULED_PAYMENT_TABLE_HEAD } from '../../components/datagrid/refund/ScheduledPaymentHead';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import BankAccountDetails from '../../components/datagrid/refund/Components/BankAccountDetails';
import GlobalSelectFieldWithoutFormikNew from '../../components/mui/GlobalSelectFieldWithoutFormikNew';
import FromAndToDatePicker from '../../components/mui/FromAndToDatePicker';
import dayjs from 'dayjs';
import {
  getSchedulePaymentsForEnrolledStudents,
  getSchedulePaymentsForNonEnrolledStudents,
} from '../../redux/features/refundSlice';
import { useDispatch } from 'react-redux';
import ChangeTransactionDate from './ChangeTransactionDate';
import UpdatePaymentStatus from './MarkAsPaid';
import { typeOfStudent } from '../../utils/constants/GlobalStaticData';
const refundStatus = [
  { id: -1, label: 'All' },
  { id: 0, label: 'Pending' },
  { id: 1, label: 'Paid' },
];


const ScheduledPayments = () => {
  const [openModalComponentName, setOpenModalComponentName] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  const [selectedStatus, setSelectedStatus] = useState({});
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, scheduledPayments } = useSelector((state) => state.refund);
  const [open, setOpen] = useState(false);
  // const REFUND_SCHEDULED_PAYMENT_TABLE_HEAD_JSON = useMemo(() => REFUND_SCHEDULED_PAYMENT_TABLE_HEAD({ setOpen }), []);
  const dispatch = useDispatch();
  const dispatchParams = useMemo(() => {
    return {
      gridSize,
      pageNum,
      search,
      fromDate,
      toDate,
      status: selectedStatus?.id,
      type: 2,
    };
  }, [pageNum, gridSize, search, fromDate, toDate, selectedStatus]);

  useEffect(() => {
    dispatch(
      selectedType?.id
        ? getSchedulePaymentsForNonEnrolledStudents(dispatchParams)
        : getSchedulePaymentsForEnrolledStudents(dispatchParams)
    );
  }, [dispatch, selectedType, dispatchParams]);

  const columns = useMemo(() => {
    return REFUND_SCHEDULED_PAYMENT_TABLE_HEAD({
      nonEnrollment: selectedType.id == 1,
      setOpenModalComponentName,
      setSelectedRow,
    });
  }, [selectedType]);

  const modalComponents = [
    {
      title: 'Bank Details',
      content: <BankAccountDetails nonEnrollment={selectedType.id == 1} rowData={selectedRow} />,
    },
    {
      title: 'Update Transaction Date',
      content: (
        <ChangeTransactionDate
          nonEnrollment={selectedType.id == 1}
          rowData={selectedRow}
          setOpen={setOpenModalComponentName}
          dispatchParams={dispatchParams}
          apiAfterSuccess={
            selectedType?.id ? getSchedulePaymentsForNonEnrolledStudents : getSchedulePaymentsForEnrolledStudents
          }
        />
      ),
    },
    {
      title: 'Mark As Paid',
      content: (
        <UpdatePaymentStatus
          nonEnrollment={selectedType.id == 1}
          rowData={selectedRow}
          setOpen={setOpenModalComponentName}
          dispatchParams={dispatchParams}
          apiAfterSuccess={
            selectedType?.id ? getSchedulePaymentsForNonEnrolledStudents : getSchedulePaymentsForEnrolledStudents
          }
        />
      ),
    },
  ];

  const contentRenderFunction = (title) => {
    const component = modalComponents.find((c) => c.title === title);
    return component ? component.content : null;
  };

  return (
    <>
      <GlobalWrapper title={'Scheduled Payments'}>
        <Grid container spacing={2} my={3}>
          <Grid item xs={12} md={6} lg={4}>
            <FromAndToDatePicker
              disabled={false}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
              fullWidth={true}
            />
          </Grid>

          {/* <Grid item xs={12} md={6} lg={4}>
            <GlobalSelectFieldWithoutFormikNew
              keys={{ itemId: 'id', itemValue: 'label' }}
              data={refundStatus}
              label={'Payment Status'}
              fullWidth={true}
              selectedDetails={selectedStatus}
              setChange={setSelectedStatus}
            />
          </Grid> */}
          <Grid item xs={12} md={6} lg={4}>
            <GlobalSelectFieldWithoutFormikNew
              keys={{ itemId: 'id', itemValue: 'name' }}
              data={typeOfStudent}
              label={'Student Type'}
              fullWidth={true}
              selectedDetails={selectedType}
              setChange={setSelectedType}
            />
          </Grid>
        </Grid>

        <Box sx={{ width: '100%' }}>
          <GlobalDatagrid
            tableHead={columns}
            rowUniqueId={'sl_no'}
            rows={scheduledPayments?.data}
            meta={scheduledPayments?.meta?.totalRecords}
            loading={loading}
          />
        </Box>
        <Box>
          <GlobalDialog
            title={openModalComponentName}
            open={Boolean(openModalComponentName)}
            setOpen={setOpenModalComponentName}
            closeButton={true}
            content={contentRenderFunction(openModalComponentName)}
            // maxWidth={"md"}
          />
        </Box>
      </GlobalWrapper>
    </>
  );
};

export default ScheduledPayments;
